import { Grid, Skeleton, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

import { OverviewSkeletonStaticBlock } from '@/components/StaticBlock/OverviewSkeletonStaticBlock';

export const OrganizationSettingComponentSkeleton = () => {
  return (
    <StyledGrid
      container
      spacing={{ xs: 2, md: 3 }}
      data-testid="organization-setting-component-skeleton"
    >
      <StyledGridItem size={{ xs: 12, md: 4 }}>
        <OverviewSkeletonStaticBlock>
          <StackStyles>
            <Skeleton width={200} />
            <Skeleton width={200} />
            <Skeleton width={200} />
          </StackStyles>
        </OverviewSkeletonStaticBlock>

        <OverviewSkeletonStaticBlock>
          <StackStyles>
            <Skeleton width={200} />
            <Skeleton width={200} />
            <Skeleton width={200} />
          </StackStyles>
        </OverviewSkeletonStaticBlock>
      </StyledGridItem>

      <StyledGridItem size={{ xs: 12, md: 4 }}>
        <OverviewSkeletonStaticBlock>
          <StackStyles>
            <Skeleton width={200} />
            <Skeleton width={200} />
            <Skeleton width={200} />
          </StackStyles>
        </OverviewSkeletonStaticBlock>
        <OverviewSkeletonStaticBlock>
          <StackStyles>
            <Skeleton width={200} />
            <Skeleton width={200} />
            <Skeleton width={200} />
          </StackStyles>
        </OverviewSkeletonStaticBlock>
      </StyledGridItem>

      <StyledGridItem size={{ xs: 12, md: 4 }}>
        <OverviewSkeletonStaticBlock>
          <StackStyles>
            <Skeleton width={200} />
            <Skeleton width={200} />
            <Skeleton width={200} />
          </StackStyles>
        </OverviewSkeletonStaticBlock>
        <OverviewSkeletonStaticBlock>
          <StackStyles>
            <Skeleton width={200} />
            <Skeleton width={200} />
            <Skeleton width={200} />
          </StackStyles>
        </OverviewSkeletonStaticBlock>
      </StyledGridItem>
    </StyledGrid>
  );
};

const StyledGrid = styled(Grid)({
  display: 'flex',
  justifyContent: 'center',
});

const StyledGridItem = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

const StackStyles = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));
